import React from "react";
import DownCaretIcon from "../../Layout/Icons/DownCaretIcon";

const CurrentValues = ({
  quantity,
  initialPrice,
  totalPrice,
  totalSavings,
  handleOpenDropdown
}) => {
  return (
    <div
      className="quantity__current current-qty"
      onClick={(event) => {
        event.stopPropagation();
        handleOpenDropdown();
      }}
    >
      <div className="current-qty__quantity">{quantity}</div>

      {totalSavings <= 0 ? (
        <div className="current-qty__price">${totalPrice}</div>
      ) : (
        <div className="current-qty__price">
          <span className="current-qty__crossout">
            ${(initialPrice * quantity).toFixed(2)}
          </span>
          <span className="current-qty__savings">
            &nbsp;&nbsp;${totalPrice}
          </span>
        </div>
      )}

      <div className="quantity__arrow">
        <DownCaretIcon />
      </div>
    </div>
  );
};

export default CurrentValues;
